// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trimmer_wrapper__LX\\+S9 {
  display: flex;
  align-items: center;

  width: 100%;
  height: 52px;

  position: relative;
  outline: none;
}

.trimmer_backgroundLine__aG8pS {
  width: 100%;
  height: 4px;

  position: absolute;
  left: 0;

  border-radius: 2px;
  pointer-events: none;
}

.trimmer_currentTimeIndicator__2b7Dd {
  width: 1px;
  height: 54px;

  position: absolute;
  bottom: 0;
  z-index: 1;

  background: white;
  pointer-events: none;
  transition: opacity 0.2s;
}

.trimmer_currentTimeIndicator__2b7Dd::before {
  content: '';
  display: block;
  position: absolute;
  top: -16px;
  transform: translateX(-48%);
  border-top: 18px solid white;
  border-bottom: none;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
}

.trimmer_hoverIndicator__NYrjR {
  width: 1px;
  height: 63px;

  position: absolute;
  bottom: 0;

  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
}

.trimmer_wrapper__LX\\+S9:hover .trimmer_hoverIndicator__NYrjR {
  opacity: 1;
}

@media (prefers-reduced-motion) {
  .trimmer_hoverIndicator__NYrjR {
    transition: none;
  }
}

.trimmer_trimArea__1Tksc {
  height: 100%;
  min-width: 22px;
  position: absolute;
  border: 2px solid var(--primaryColor);
  pointer-events: none;
}

/* Background for .trimArea is created as a pseudo-element because its color
is dynamic and we want to add opacity to it and we can't do something like
\`background: rgba(var(--primaryColor), 0.2);\` with CSS just yet */
.trimmer_trimArea__1Tksc::after {
  content: '';

  width: 100%;
  height: 100%;

  position: absolute;
  top: 0;
  left: 0;

  background: var(--primaryColor);
  opacity: 0.2;
}

.trimmer_label__L1xfa {
  position: absolute;
  top: -17px;

  font-size: 10px;
  transition: transform 0.2s;
}

.trimmer_label__L1xfa:nth-child(1) {
  left: -2px;
}

.trimmer_label__L1xfa:nth-child(2) {
  right: -2px;
}

.trimmer_trimArea__1Tksc.trimmer_narrow__0Wfqw .trimmer_label__L1xfa:nth-child(1) {
  transform: translateX(-100%);
}

.trimmer_trimArea__1Tksc.trimmer_narrow__0Wfqw .trimmer_label__L1xfa:nth-child(2) {
  transform: translateX(100%);
}

.trimmer_trimArea__1Tksc button {
  height: 100%;
  padding: 0;

  position: absolute;
  z-index: 1;

  background: none;
  border: none;
  outline: none;
  cursor: col-resize;
  pointer-events: all;
}

.trimmer_trimArea__1Tksc button:focus-visible svg {
  outline: 2px solid var(--primaryColor);
}

.trimmer_trimArea__1Tksc button:nth-of-type(1) {
  left: -11px;
}

.trimmer_trimArea__1Tksc button:nth-of-type(2) {
  right: -11px;
}

.trimmer_trimArea__1Tksc button svg {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/trimmer/trimmer.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;;EAEnB,WAAW;EACX,YAAY;;EAEZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;;EAEX,kBAAkB;EAClB,OAAO;;EAEP,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,YAAY;;EAEZ,kBAAkB;EAClB,SAAS;EACT,UAAU;;EAEV,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;EACnB,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,YAAY;;EAEZ,kBAAkB;EAClB,SAAS;;EAET,oCAAoC;EACpC,UAAU;EACV,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;;iEAEiE;AACjE;EACE,WAAW;;EAEX,WAAW;EACX,YAAY;;EAEZ,kBAAkB;EAClB,MAAM;EACN,OAAO;;EAEP,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;;EAEV,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,UAAU;;EAEV,kBAAkB;EAClB,UAAU;;EAEV,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n\n  width: 100%;\n  height: 52px;\n\n  position: relative;\n  outline: none;\n}\n\n.backgroundLine {\n  width: 100%;\n  height: 4px;\n\n  position: absolute;\n  left: 0;\n\n  border-radius: 2px;\n  pointer-events: none;\n}\n\n.currentTimeIndicator {\n  width: 1px;\n  height: 54px;\n\n  position: absolute;\n  bottom: 0;\n  z-index: 1;\n\n  background: white;\n  pointer-events: none;\n  transition: opacity 0.2s;\n}\n\n.currentTimeIndicator::before {\n  content: '';\n  display: block;\n  position: absolute;\n  top: -16px;\n  transform: translateX(-48%);\n  border-top: 18px solid white;\n  border-bottom: none;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n}\n\n.hoverIndicator {\n  width: 1px;\n  height: 63px;\n\n  position: absolute;\n  bottom: 0;\n\n  background: rgba(255, 255, 255, 0.5);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s;\n}\n\n.wrapper:hover .hoverIndicator {\n  opacity: 1;\n}\n\n@media (prefers-reduced-motion) {\n  .hoverIndicator {\n    transition: none;\n  }\n}\n\n.trimArea {\n  height: 100%;\n  min-width: 22px;\n  position: absolute;\n  border: 2px solid var(--primaryColor);\n  pointer-events: none;\n}\n\n/* Background for .trimArea is created as a pseudo-element because its color\nis dynamic and we want to add opacity to it and we can't do something like\n`background: rgba(var(--primaryColor), 0.2);` with CSS just yet */\n.trimArea::after {\n  content: '';\n\n  width: 100%;\n  height: 100%;\n\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  background: var(--primaryColor);\n  opacity: 0.2;\n}\n\n.label {\n  position: absolute;\n  top: -17px;\n\n  font-size: 10px;\n  transition: transform 0.2s;\n}\n\n.label:nth-child(1) {\n  left: -2px;\n}\n\n.label:nth-child(2) {\n  right: -2px;\n}\n\n.trimArea.narrow .label:nth-child(1) {\n  transform: translateX(-100%);\n}\n\n.trimArea.narrow .label:nth-child(2) {\n  transform: translateX(100%);\n}\n\n.trimArea button {\n  height: 100%;\n  padding: 0;\n\n  position: absolute;\n  z-index: 1;\n\n  background: none;\n  border: none;\n  outline: none;\n  cursor: col-resize;\n  pointer-events: all;\n}\n\n.trimArea button:focus-visible svg {\n  outline: 2px solid var(--primaryColor);\n}\n\n.trimArea button:nth-of-type(1) {\n  left: -11px;\n}\n\n.trimArea button:nth-of-type(2) {\n  right: -11px;\n}\n\n.trimArea button svg {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `trimmer_wrapper__LX+S9`,
	"backgroundLine": `trimmer_backgroundLine__aG8pS`,
	"currentTimeIndicator": `trimmer_currentTimeIndicator__2b7Dd`,
	"hoverIndicator": `trimmer_hoverIndicator__NYrjR`,
	"trimArea": `trimmer_trimArea__1Tksc`,
	"label": `trimmer_label__L1xfa`,
	"narrow": `trimmer_narrow__0Wfqw`
};
export default ___CSS_LOADER_EXPORT___;
